import { firestore } from "../services/firebase";
import { collection, getDocs } from "firebase/firestore";

// Exemplo: busca de uma coleção "dynamic_ui" no Firestore
export async function fetchDynamicConfig() {
  if (!firestore) {
    throw new Error("Firestore instance is not initialized.");
  }
  const col = collection(firestore, "dynamic_ui");
  const snapshot = await getDocs(col);
  // Cada documento deve conter { type, content, position? }
  return snapshot.docs.map(doc => doc.data());
}

// Para testes locais, você pode usar um mock:
// export async function fetchDynamicConfig() {
//   return [
//     {
//       type: "card",
//       content: {
//         component: "form",
//         props: {
//           config: {
//             title: "Cadastro",
//             fields: [[{ id: "nome", type: "input", label: "Nome" }]],
//             buttons: [{ title: "Salvar", action: "create" }]
//           },
//           collectionName: "usuarios",
//           mode: "create"
//         }
//       }
//     },
//     {
//       type: "modal",
//       content: {
//         component: "list",
//         props: {
//           title: "Usuários",
//           listKey: "usuarios"
//         },
//         open: true
//       }
//     }
//   ];
// }